/* Utilities shared by the Healing Socials pages. */

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];
const WEEKDAYS = [
  "Sunday", "Monday", "Tuesday", "Wednesday",
  "Thursday", "Friday", "Saturday",
];

const parseDate = (iso) => {
  // iso = "YYYY-MM-DD" — avoid timezone drift by parsing as local date
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const dateParts = (iso) => {
  const dt = parseDate(iso);
  if (!dt) return { month: "", day: "", weekday: "", year: "", longMonth: "" };
  return {
    month: MONTHS_SHORT[dt.getMonth()],
    longMonth: MONTHS[dt.getMonth()],
    day: String(dt.getDate()).padStart(2, "0"),
    weekday: WEEKDAYS[dt.getDay()],
    year: dt.getFullYear(),
    weekdayShort: WEEKDAYS[dt.getDay()].slice(0, 3),
  };
};

export const prettyDate = (iso) => {
  const dt = parseDate(iso);
  if (!dt) return "";
  return `${WEEKDAYS[dt.getDay()]}, ${MONTHS[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
};

/* Convert human time like "6:30 PM" to 24h "HH:MM". Returns null on failure. */
const to24h = (txt) => {
  if (!txt) return null;
  const m = txt.trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/i);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const mins = m[2] ? parseInt(m[2], 10) : 0;
  const ap = (m[3] || "").toLowerCase();
  if (ap === "pm" && h < 12) h += 12;
  if (ap === "am" && h === 12) h = 0;
  if (h < 0 || h > 23 || mins < 0 || mins > 59) return null;
  return `${String(h).padStart(2, "0")}${String(mins).padStart(2, "0")}`;
};

export const googleCalendarUrl = (event) => {
  const d = parseDate(event.date);
  if (!d) return "#";
  const startHM = to24h(event.start_time) || "1800";
  const endHM = to24h(event.end_time) || (() => {
    // default: start + 2h
    const sh = parseInt(startHM.slice(0, 2), 10);
    const sm = parseInt(startHM.slice(2), 10);
    const t = new Date(d);
    t.setHours(sh, sm + 120);
    return `${String(t.getHours()).padStart(2, "0")}${String(t.getMinutes()).padStart(2, "0")}`;
  })();
  const yyyymmdd = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
  const dates = `${yyyymmdd}T${startHM}00/${yyyymmdd}T${endHM}00`;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title || "Shiva Murti Healing Social",
    dates,
    details: event.tagline || "An in-person Healing Social with Shiva Murti Sacred Healing Arts.",
    location: `${event.venue || ""}${event.address ? ", " + event.address : ""}`.trim(),
  });
  return `https://www.google.com/calendar/render?${params.toString()}`;
};

export const mapsUrl = (address) => {
  if (!address) return "#";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
};
